<div>
  <mat-card class="pt-3 results">
    <div class="actions content">
      <div class="float-left mt-1">
        <div>
          <form [formGroup]="searchForm">
            <mat-form-field appearance="outline" class="w-120">
              <mat-label>Date Select</mat-label>
              <mat-select (selectionChange)="onDateFilterSelected($event)"
                          [value]="selectedDateField + '@'+ selectedDateFilterString!">
                <mat-option *ngFor="let dateFilter of createDateFilters"
                            [value]="dateFilter.title + '@'+ dateFilter.filterString">
                  {{dateFilter.title}}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline" class="w-230" *ngIf="selectedDateField === 'Custom'">
              <mat-label>Enter Date Range</mat-label>
              <mat-date-range-input
                [formGroup]="customDateFormGroup"
                [rangePicker]="picker">
                <input matStartDate formControlName="startDate" placeholder="From date" [value]="customStartDate"
                       (keyup.enter)="onCustomDateFilterSelected()">
                <input matEndDate formControlName="endDate" placeholder="To date" [value]="customEndDate"
                       (keyup.enter)="onCustomDateFilterSelected()">
              </mat-date-range-input>
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-date-range-picker #picker>
                <mat-date-range-picker-actions>
                  <button mat-button matDateRangePickerCancel>Cancel</button>
                  <button mat-raised-button color="primary" matDateRangePickerApply
                          (click)="onCustomDateFilterSelected()">Apply
                  </button>
                </mat-date-range-picker-actions>
              </mat-date-range-picker>
            </mat-form-field>
            <mat-form-field appearance="outline" class="w-400">
              <input type="text" formControlName="searchText" matInput
                     placeholder="Search by name or ID (min. 2 characters)"
                     (keyup.enter)="searchForm.get('searchText')?.value.trim().length >= 2? onSearch($event) : false"
                     (input)="onSearchInputChanges($event)">
            </mat-form-field>
          </form>
        </div>
      </div>
      <div class="float-left mt-2">
        <button mat-stroked-button (click)="onSearch($event)" *ngIf="allowApplicationSearch"
                [disabled]="disableSearchButton">Search
        </button>
      </div>
      <div class="float-right">
        <div class="mt-2"></div>
        <button *ngIf="isOldFilter" mat-stroked-button type="button" (click)="onAddFilterClicked($event)"
                [disabled]="!canAddFilter">
          <mat-icon inline="true">filter_list</mat-icon>
          Filter
        </button>
        <button mat-stroked-button (click)="onDownloadResultsClick($event, false)"
                aria-label="Example icon button with a filter list icon"
                [hidden]="!canExport">
          <mat-icon inline="true">save_alt</mat-icon>
          Export
        </button>
      </div>
      <div *ngIf="isOldFilter" class="clear"></div>
      <ng-container *ngIf="isOldFilter">
        <div class="d-flex">
          <div *ngIf="showAddFilterForm">
            <div class="float-left">
              <form [formGroup]="filterForm">
                <mat-form-field appearance="outline">
                  <mat-label>Fields</mat-label>
                  <mat-select formControlName="field" id="filterFieldSelect"
                              (selectionChange)="onFilterSelected($event)">
                    <mat-option *ngFor="let filter of availableFilters" [value]="filter.fieldName">
                      {{filter.displayText}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                <mat-form-field appearance="outline">
                  <mat-label>Operator</mat-label>
                  <mat-select formControlName="operator" id="filterOperatorSelect"
                              (selectionChange)="onOperatorSelect($event)">
                    <mat-option *ngFor="let operator of operators" [value]="operator.value">
                      {{operator.displayText}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>

                <mat-form-field appearance="outline" *ngIf="selectedField === 'brand'">
                  <mat-label>Criteria</mat-label>
                  <mat-select #criteriaMatSelect formControlName="criteria" id="filterBrand" multiple>
                    <mat-option *ngFor="let brand of brands" [value]="brand.value">
                      {{brand.displayText}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>

                <mat-form-field appearance="outline" *ngIf="selectedField === 'productCode'">
                  <mat-label>Criteria</mat-label>
                  <mat-select formControlName="criteria" id="filterProduct" multiple>
                    <mat-option *ngFor="let product of filteredProducts" [value]="product.value">
                      {{product.displayText}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>

                <mat-form-field appearance="outline" *ngIf="selectedField === 'branch'">
                  <mat-label>Criteria</mat-label>
                  <mat-select #criteriaMatSelect formControlName="criteria" id="filterBranch" multiple>
                    <mat-option *ngFor="let branch of branchList" [value]="branch.value">
                      {{branch.displayText}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>

                <mat-form-field appearance="outline" *ngIf="selectedField === 'status'">
                  <mat-label>Criteria</mat-label>
                  <mat-select formControlName="criteria" id="filterStatus" multiple>
                    <mat-option *ngFor="let status of applicationStatus" [value]="status.value">
                      {{status.displayText}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>

                <mat-form-field appearance="outline" *ngIf="selectedField === 'applicationChannelId'">
                  <mat-label>Criteria</mat-label>
                  <mat-select #criteriaMatSelect formControlName="criteria" id="filterChannel" multiple>
                    <mat-option *ngFor="let channel of channels" [value]="channel.value">
                      {{channel.displayText}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                <mat-form-field appearance="outline" *ngIf="selectedField === 'isJoint'">
                  <mat-label>Criteria</mat-label>
                  <mat-select #criteriaMatSelect formControlName="criteria" id="filterOwnership" multiple>
                    <mat-option *ngFor="let ownership of ownerships" [value]="ownership.value">
                      {{ownership.displayText}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>

                <mat-form-field appearance="outline" *ngIf="selectedField === 'ssn'">
                  <mat-label>Criteria</mat-label>
                  <input matInput type="text" formControlName="criteria" id="filterCriteria"
                         (keyup.enter)="onAddFilterClicked($event)">
                </mat-form-field>
                <ng-container *ngIf="selectedField === 'rcCode'">
                  <mat-form-field appearance="outline">
                    <mat-label>Criteria</mat-label>
                    <mat-select #criteriaMatSelect formControlName="criteria" id="filterReferenceCode" multiple>
                      <mat-option *ngFor="let referenceCode of referenceCodes" [value]="referenceCode.value">
                        {{referenceCode.displayText}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </ng-container>

              </form>
            </div>
            <div class="mt-1 float-right">
              <button mat-stroked-button type="button" color="" (click)="onSaveFilterClicked($event)"
                      [disabled]="!canApplyFilter">
                Apply
              </button>
              <button mat-button type="button" color="" (click)="onCancelFilterClicked($event)">
                Cancel
              </button>
            </div>
          </div>
        </div>
      </ng-container>
      <app-custom-filter *ngIf="!isOldFilter" [fieldName]="fieldName" (clearFilters)="clearAllFilters()"
                         (applyFilters)="applyFilter($event)"></app-custom-filter>

      <div *ngIf="!isOldFilter" class="clear"></div>

      <div class="d-flex">
        <ng-container *ngIf="isOldFilter">
          <button *ngIf="appliedFilters.length > 0" title="Clear All Filters" (click)="clearAllFilters()"
                  class="remove-all-filter-button"><span class="material-icons-outlined">block</span></button>
          <mat-divider *ngIf="appliedFilters.length > 0" class="filter-divider" vertical></mat-divider>
        </ng-container>

        <mat-chip-list class="selected-filter" aria-label="Applied filters" *ngIf="appliedFilters.length > 0">
          <mat-chip *ngFor="let filter of appliedFilters">
            <strong>{{filter.fieldDescription}}</strong>&nbsp;{{filter.operatorDescription}}&nbsp;<strong>{{filter.criteriaDisplayText ? filter.criteriaDisplayText : filter.criteria}}</strong>
            <button (click)="removeFilter(filter)">&times;
            </button>
          </mat-chip>
        </mat-chip-list>
      </div>
    </div>
    <div class="text-center" *ngIf="showEmptyResultMessage">No results found.<br><br></div>
    <div class="clear"></div>

    <ng-container *ngIf="!showEmptyResultMessage">
      <table mat-table [dataSource]="dataSource" class="application-table" aria-describedby="title"
             matSort matSortActive="createdDate" matSortDirection="desc"
      >
        <ng-container matColumnDef="fullName">
          <th mat-header-cell *matHeaderCellDef>Applicant(s)</th>
          <td mat-cell *matCellDef="let application">
            <span *ngFor="let applicant of application.applicants">
              {{getApplicantDisplayName(applicant)}} <br>
            </span>
          </td>
        </ng-container>
        <ng-container matColumnDef="sessionId">
          <th mat-header-cell *matHeaderCellDef>ID</th>
          <td mat-cell *matCellDef="let application">
            <span class="badge badge-stroked">{{application.sessionId.substring(24)}}</span>
          </td>
        </ng-container>
        <ng-container matColumnDef="product">
          <th [hidden]="jointApplicationRequests" mat-header-cell *matHeaderCellDef mat-sort-header="">Product</th>
          <td [hidden]="jointApplicationRequests" mat-cell *matCellDef="let application">
            <div *ngFor="let product of application.products">{{product?.productCode}} - {{product?.productDescription}}
              <ng-container *ngIf="product.productCount > 1">({{product.productCount}})</ng-container>
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="">Status</th>
          <td mat-cell *matCellDef="let application"><span
            class="{{application.mapStateForDisplay().classes}}">{{application.mapStateForDisplay().displayText}}</span>
          </td>
        </ng-container>
        <ng-container matColumnDef="createdDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Created</th>
          <td mat-cell *matCellDef="let application">{{ application.createdTimestamp | date: 'MM/dd/yyyy h:mm a' }}</td>
        </ng-container>
        <ng-container matColumnDef="rcCode">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Reference Code</th>
          <td mat-cell *matCellDef="let application">{{ application.rcCode }}</td>
        </ng-container>
        <ng-container matColumnDef="newTab">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let application">
            <button class="new-tab-button" mat-icon-button
                    (click)="onApplicationOpenRequest($event, application, true)">
              <mat-icon title="Open in New Tab">open_in_new</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row class="app-row" *matRowDef="let application; columns: displayedColumns;"
            (click)="onApplicationOpenRequest($event, application, false)">
        </tr>

      </table>
      <mat-paginator #paginator [pageSize]="defaultPageSize"
                     [length]="totalElements"
                     showFirstLastButtons [pageSizeOptions]="[10, 25, 50]"
                     aria-label="Select page of periodic elements">
      </mat-paginator>
    </ng-container>
  </mat-card>
</div>
